import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play-alt",
  "use": "play-alt-usage",
  "viewBox": "0 0 18 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 18 20\" id=\"play-alt\"><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M16.389 9.36L2.89 1.111a.75.75 0 0 0-1.141.64v16.498a.75.75 0 0 0 1.141.64l13.498-8.25a.75.75 0 0 0 0-1.279z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol